
export default class MailRoute{

    constructor(attrs) {
        this.create = 'mail';
    }

}
